import { render, staticRenderFns } from "./emergency_treatment2.vue?vue&type=template&id=4e85144e&scoped=true"
import script from "./emergency_treatment2.vue?vue&type=script&lang=js"
export * from "./emergency_treatment2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e85144e",
  null
  
)

export default component.exports